import { useCallback, useRef } from 'react';

/**
 * Keeps entity-search fields in a "committed" state after inline create:
 * avoid reopening the dropdown when focus returns after the create modal closes.
 */
export function useSearchCreateFocus() {
  const inputRef = useRef<HTMLInputElement>(null);
  const suppressFocusOpenRef = useRef(false);

  const shouldOpenOnFocus = useCallback((isCommittedSelection: boolean) => {
    if (suppressFocusOpenRef.current) {
      suppressFocusOpenRef.current = false;
      return false;
    }
    if (isCommittedSelection) return false;
    return true;
  }, []);

  const commitSelectionUi = useCallback(() => {
    suppressFocusOpenRef.current = true;
    requestAnimationFrame(() => inputRef.current?.blur());
  }, []);

  return {
    inputRef,
    shouldOpenOnFocus,
    commitSelectionUi,
  };
}
